import { Timeline } from "antd"
import SITE from "../../config/siteConfig"
import "./index.less"
const Home = props => {
  return <div className="home">
    
    {/* <Timeline>
    <Timeline.Item color="green">易洽语音对讲软件 2020-03-04</Timeline.Item>
    <Timeline.Item color="red">
      <p>易洽巡更管理系统 2019-11-09</p>
    </Timeline.Item>
    <Timeline.Item>

      <p>易洽物联卡管理系统 2019-11-08</p>
    </Timeline.Item>
    <Timeline.Item color="green">一种能实现倒地报警的对讲机 2018-04-06</Timeline.Item>
    <Timeline.Item color="gray">

      <p>易洽通信部标808定位软件 2017-06-13</p>
    </Timeline.Item>
    <Timeline.Item color="gray">
      <p>成立时间 2014年08月06日</p>
    </Timeline.Item>
  </Timeline> */}

    <h1>欢迎使用{SITE.TITLE}</h1>

  </div>
}

export default Home